import * as React from 'react';

import { cn } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';
import { Clock } from 'lucide-react';

import { $remoteExecutionRuns } from '../../_state/executionRunList.state';
import { useTranslations } from '../../i18n/useTranslations';

import { ExecutionRunCard } from './ExecutionRunCard';

export const ExecutionRunListView: React.FC = () => {
  const t = useTranslations();
  const { data, isLoading, error } = useAtomValue($remoteExecutionRuns);

  if (isLoading) {
    return (
      <div className="p-6">
        <div className="animate-pulse space-y-4">
          <div className="h-24 rounded bg-neutral/20"></div>
          <div className="h-24 rounded bg-neutral/20"></div>
          <div className="h-24 rounded bg-neutral/20"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-6">
        <div className="text-failure">
          {t.executions.errorLoading(error.message)}
        </div>
      </div>
    );
  }

  const runs = data?.runs || [];
  const total = data?.total || 0;

  return (
    <div className={cn('@ExecutionRunListView', 'space-y-4 p-6')}>
      <div>
        <h2 className="text-lg font-semibold">{t.executions.title}</h2>
        <p className="mt-1 text-sm text-neutral/60">
          {t.executions.total(total)}
        </p>
      </div>

      <div className="space-y-3">
        {runs.length === 0 ? (
          <div className="py-12 text-center">
            <div className="mb-4 text-neutral/40">
              <Clock className="mx-auto size-16" />
            </div>
            <h3 className="mb-2 text-lg font-medium">
              {t.executions.noResults}
            </h3>
            <p className="text-sm text-neutral/60">
              {t.executions.noResultsDescription}
            </p>
          </div>
        ) : (
          runs.map((run) => <ExecutionRunCard key={run.id} run={run} />)
        )}
      </div>
    </div>
  );
};
